<template>
  <span class="hl-text">
    <template v-for="(seg, idx) in segments">
      <el-tag
        v-if="seg.type === 'highlight' && variant === 'tag'"
        :key="`t-${idx}`"
        size="mini"
        type="warning"
        class="hl-tag"
      >{{ seg.value }}</el-tag>
      <mark
        v-else-if="seg.type === 'highlight' && variant === 'mark'"
        :key="`m-${idx}`"
        class="kw"
      >{{ seg.value }}</mark>
      <span v-else :key="`s-${idx}`">{{ seg.value }}</span>
    </template>
  </span>
</template>

<script>
/**
 * 通用高亮渲染组件
 *  - 输入：text 字符串（可能含 {{xxx}} 包裹的高亮段）
 *  - variant：
 *    - 'tag'  → highlight 段渲染为 <el-tag type="warning">（用于「上学/凌晨」黄色标签）
 *    - 'mark' → highlight 段渲染为 <mark class="kw">（用于聊天关键词黄底高亮）
 *  - 使用 v-for + 文本插值，不走 v-html，天然防 XSS
 */
import { parseHighlightSegments } from './utils';

export default {
  name: 'HighlightText',
  props: {
    text: {
      type: [String, Number],
      default: '',
    },
    variant: {
      type: String,
      default: 'mark',
      validator: v => v === 'tag' || v === 'mark',
    },
  },
  computed: {
    segments() {
      return parseHighlightSegments(this.text);
    },
  },
};
</script>

<style lang="less" scoped>
.hl-tag {
  margin: 0 4px 0 0;
}
.kw {
  background: #fff566;
  padding: 0 2px;
  font-weight: 600;
  border-radius: 2px;
}
</style>
